'use client';

import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './components/ui/tabs';
import { useRouter, useSearchParams } from 'next/navigation';
import AdminHomeConsignorsTab from './consignors/AdminHomeConsignorsTab';
import { Auction, Consignor, User } from '@prisma/client';
import AdminHomeOverviewTab from './AdminHomeOverviewTab';
import { AuctionWithRevenue } from './api/revenue/route';
import AdminHomeBiddersTab from './(bidders)/AdminHomeBiddersTab';
import { BidderTableData } from './(bidders)/columns';
import { AugmentedConsignor } from './consignors/columns';

interface Props {
  tab?: string;
  consignors: AugmentedConsignor[];
  bidders: BidderTableData[];
  previousAuctions: AuctionWithRevenue[];
}

export enum AdminHomeTabs {
  OVERVIEW = "overview",
  CONSIGNORS = "consignors",
  BIDDERS = "bidders",
}

const AdminTabs = ({ tab, consignors, bidders, previousAuctions }: Props) => {
  const handleValueChange = (value: string) => {
    const params = new URLSearchParams();
    params.set("tab", value);
    const paramString = params.toString();
    const query = paramString ? "?" + paramString : "";
    window.history.pushState({}, '', `/${query}`);
  }

  return (
    <Tabs
      defaultValue={(tab && tab.toUpperCase() in AdminHomeTabs) ?
        tab :
        AdminHomeTabs.OVERVIEW}
      onValueChange={handleValueChange}
      className="w-full"
    >
      <TabsList>
        <TabsTrigger value={AdminHomeTabs.OVERVIEW}>Overview</TabsTrigger>
        <TabsTrigger value={AdminHomeTabs.BIDDERS}>Bidders</TabsTrigger>
        <TabsTrigger value={AdminHomeTabs.CONSIGNORS}>Consignors</TabsTrigger>
      </TabsList>
      <TabsContent value={AdminHomeTabs.OVERVIEW}>
        <AdminHomeOverviewTab previousAuctions={previousAuctions} />
      </TabsContent>
      <TabsContent value={AdminHomeTabs.CONSIGNORS}>
        <AdminHomeConsignorsTab consignors={consignors} />
      </TabsContent>
      <TabsContent value={AdminHomeTabs.BIDDERS}>
        <AdminHomeBiddersTab bidders={bidders} />
      </TabsContent>
    </Tabs>
  );
}

export default AdminTabs
